import { nextTick } from 'vue'
import CUSTOM_FIELD_TYPES from '@/constants/customFieldTypes'

export default function(hearingFieldConfig?: HearingFieldConfig, inputHearingFields?: Inputs) {
  /**
   * サーバから受け取ったヒアリング項目の内容を local state の input の型に assign
   */
  const initInputHearingFields = (): void => {
    let _value: InputValue | undefined = undefined

    nextTick(() => {
      hearingFieldConfig?.sections.forEach(section => {
        section.items.forEach(v => {
          _value = v.value !== undefined && v.value !== null
            ? v.value
            : v.fieldType === CUSTOM_FIELD_TYPES.TEXT || v.fieldType === CUSTOM_FIELD_TYPES.SELECT_SINGLE
              ? ''
              : v.fieldType === CUSTOM_FIELD_TYPES.CHECKBOX_MULTI || v.fieldType === CUSTOM_FIELD_TYPES.SELECT_MULTI
                ? []
                : 0
          if (inputHearingFields) {
            Object.assign(inputHearingFields, {
              [`${v.name}`]: {
                name: `${v.name}${hearingFieldConfig.nameSuffix.value}`,
                value: _value,
                validationScheme: v.validationScheme,
              }
            })
          }

          // フィールドタイプがテキストボックスか、または ON / OFF タイプのチェックボックスの場合は、追加質問項目は省略
          if (v.fieldType === CUSTOM_FIELD_TYPES.TEXT || v.fieldType === CUSTOM_FIELD_TYPES.CHECKBOX) return

          /**
           * 追加質問がある場合の初期処理
           */
          if (v.secondary && v.secondary.primaryItemValues) {
            const isValidType = Array.isArray(v.secondary.primaryItemValues) && v.secondary.primaryItemValues.every(item =>
              typeof item === 'string' || typeof item === 'number'
            )
            const isValidValue = v.secondary.primaryItemValues.every(val =>
              v.selectItems?.some(selector => selector.value === val)
            )

            if (!isValidType || !isValidValue) {
              console.warn('invalid pairing value with primary item.')
              return
            }

            /**
             * 退避用オブジェクトの生成
             *
             * @description
             *  追加質問項目は、「その他」が選ばれたときしか表示されないため、
             *  「その他」以外が選ばれている場合においても state の input プロパティにオブジェクトが存在してしまうと、
             *  追加質問項目未入力の影響でバリデーションに引っかかり続けてしまうため、
             *  「その他」が選ばれた場合のみ、state にオブジェクトをバインドし、バリデーションの対象とさせる。
             */
            if (
              v.value &&
              v.secondary.primaryItemValues.some(val => (v.value as ReadonlyArray<string | number>).includes(val))
            ) {
              if (inputHearingFields) {
                Object.assign(inputHearingFields, {
                  [`${v.name}${hearingFieldConfig.nameSuffix.secondaryValue}`]: {
                    name: `${v.name}${hearingFieldConfig.nameSuffix.secondaryValue}`,
                    value: v.secondary.fieldType === CUSTOM_FIELD_TYPES.CHECKBOX_MULTI || v.secondary.fieldType === CUSTOM_FIELD_TYPES.SELECT_MULTI
                      ? v.secondary.value || []
                      : v.secondary.fieldType === CUSTOM_FIELD_TYPES.CHECKBOX
                        ? v.secondary.value || 0
                        : v.secondary.value || '',
                    validationScheme: v.secondary.validationScheme,
                  }
                })
              }
            }
          }
        })
      })
    })
  }

  /**
   * ブラウザの「戻る」・「進む」が押下された際にカスタムフィールドのデータを初期化する
   * @description 基本、「戻る」・「進む」であっても、JS オブジェクト自体は揮発するが、
   *              テキストフィールド系以外のフォーム系 HTML 要素（select や checkbox 等）は、見た目上選択されているかのような表示になってしまうため、
   *              結果、JS オブジェクトである state の内容は揮発しているが、HTML 要素側の「見た目上」は、さも選択されているかのように振る舞われており、state との乖離が発生する。
   *              よって、ブラウザのイベントが発火する際にカスタムフィールドの初期化を行うことで、明示的にコンポーネントの watcher を動かし、初期化データでバインドしてからブラウザ遷移させる
   */
  window.addEventListener('pagehide', () => {
    if (hearingFieldConfig && inputHearingFields) {
      initInputHearingFields()
    }
  })

  return {
    // methods
    initInputHearingFields,
  }
}
